export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001/api/v1',
  WHATSAPP_BASE_URL: import.meta.env.VITE_WHATSAPP_API_URL || 'http://localhost:3001/api/v1',
  META_BASE_URL: import.meta.env.VITE_META_API_URL || 'http://localhost:3001/api/v1',
  AI_ANALYTICS_BASE_URL:
    import.meta.env.VITE_AI_ANALYTICS_URL || 'https://backend-wenextai-dev.v6hisj.easypanel.host/api',
  BUILDER_API_URL: import.meta.env.VITE_BUILDER_API_URL || 'http://localhost:3002/api/v1',
} as const;

export const API_ENDPOINTS = {
  AUTH: '/auth',

  USERS: '/users',
  PROFILE: '/profile',
  TEAMS: '/teams',
  BUSINESS_ACCOUNTS: '/business-accounts',
  CONTACTS: '/contacts',
  CONVERSATIONS: '/conversations',
  MESSAGES: '/messages',
  TEMPLATES: '/templates',
  TEMPLATE_LIBRARY: '/template-library',
  CAMPAIGNS: '/campaigns',
  AUTOMATION_FLOWS: '/automation/flows',
  AUDIT_LOGS: '/audit-logs',
  TICKETS: '/tickets',
  REMINDERS: '/reminders',
  CRM_NOTES: '/crm/notes',
  CRM_ACTIVITIES: '/crm/activities',
  CRM_FILES: '/crm/files',
  MEDIA_FILES: '/media',
  DASHBOARD_STATS: '/dashboard/stats',
  DASHBOARD_AI_CREDITS: '/dashboard/ai-credits',
  AGENT_DASHBOARD: '/analytics/agent/dashboard',
  DATA_STORES: '/data-stores',

  WHATSAPP_TEMPLATES: '/whatsapp/templates',
  WHATSAPP_FLOWS: '/whatsapp/flows',

  CAMPAIGN_RECIPIENTS: (campaignId: string) => `/campaigns/${campaignId}/recipients`,
  FLOW_EXECUTIONS: (flowId: string) => `/automation/flows/${flowId}/executions`,

  HEALTH: '/health',
  STATS: '/stats',

  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_CLIENTS: '/admin/clients',
  ADMIN_USERS: '/admin/users',
  ADMIN_TEMPLATES: '/admin/templates',
  ADMIN_LIBRARY: '/admin/library',
  ADMIN_SENDING_ACCOUNT: '/admin/sending-account',
  LIBRARY: '/library',

  META: '/meta',
} as const;

export const HTTP_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE',
} as const;

export interface ApiResponse<T = any> {
  data: T;
  error: string | null;
  code?: string;
  statusCode?: number;
  count?: number;
  totalCount?: number;
  filteredTotalCount?: number;
  unreadCount?: number;
  hasMore?: boolean;
  message?: string;
  success?: boolean;
  details?: string;
  meta?: any;
  alreadyCustomer?: boolean; // Flag for convert to customer when contact already has order
  done?: boolean;
  deletedRecipients?: number;
  pagination?: {
    currentPage: number;
    totalPages: number;
    pageSize: number;
    totalCount: number;
  };
  nextPageToken?: string | null;
  flow?: { id: string; name: string };
  limit?: number;
  warning?: string;
  stats?: any;
  meta_error?: any;
}

export interface ApiError {
  error: string;
  message?: string;
  details?: string;
  statusCode?: number;
}

export interface RequestOptions {
  method?: keyof typeof HTTP_METHODS;
  headers?: Record<string, string>;
  body?: any;
}
